// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"automatic_notes-module_wrapper_e128f","title":"automatic_notes-module_title_b8e6e","text":"automatic_notes-module_text_3d897"};